module.exports = __webpack_public_path__ + "img/wardInfoYellowBrown.cd7e8428.svg";